import Footer from 'csdd_components/Footer';
import HomeNavBar from 'csdd_components/HomeNavBar';
import IndustryUpdatesContent from 'csdd_components/IndustryUpdatesContent';
import IndustryUpdatesHeader from 'csdd_components/IndustryUpdatesHeader';
import Newsletter from 'csdd_components/Newsletter';
import TopNavBar from 'csdd_components/TopNavBar';

const IndustryUpdates = () => {
  return (
    <>
      <TopNavBar />
      <HomeNavBar />
      <IndustryUpdatesHeader />
      <IndustryUpdatesContent />
      <Newsletter />
      <Footer />
    </>
  );
};
export default IndustryUpdates;
